import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-create-resume-field',
  templateUrl: './create-resume-field.component.html',
  styleUrls: ['./create-resume-field.component.scss']
})
export class CreateResumeFieldComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
